'use client'
import Link from "next/link"
import dynamic from "next/dynamic";
import { Disclosure } from '@headlessui/react'

const Map = dynamic(() => import("@components/Map"), {
    loading: () => <p className="text-secondary">Loading map...</p>,
    ssr: false, // Disable server-side rendering
});

const Location = ({ districts, location, latitude, longitude, dictionary, lang }) => {

    return (
        <div className='sm:mb-3 mb-0 sm:pb-3 pb-0'>
            <h2 className='text-maincolor font-semibold text-xl mb-1'>{dictionary.location}</h2>
            <div className="flex flex-col ">
                <Map latitude={latitude} longitude={longitude} lang={lang} />
            </div>
        </div>
    )
}

export default Location